import {createLoaderWorker} from '@kibeo/loaders.gl-loader-utils';
import {NullLoader} from '../null-loader';

createLoaderWorker(NullLoader);
